module.exports = __webpack_public_path__ + "static/media/chevron-right-solid.1fce7054.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/img/chevron-right-solid.svg
// module id = 146
// module chunks = 0